import React, {
  useState, useRef, useEffect,
} from 'react';
import {
  Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot,
} from '@material-ui/lab';
// import { TextField, MenuItem } from '@material-ui/core';
import axios from 'axios';
import { toast } from 'react-toastify';

import { fixTimezoneOffset, monthNames } from 'utils/dateFunctions';
import { useEHRContext } from 'contexts/EHRContext';
import { endpoints, currentMode, docTypes } from 'configs';
import xdsToken from 'services/xdsToken';
import { logDebug, retrieveData } from 'utils/AuxiliarFunctions';
import { ToastMessage } from 'components';
// import { FaCaretDown, FaCaretUp, FaSearch } from 'react-icons/fa';
import { EHRTimelineCard } from '../EHRTimelineCard';

import './EHRTimeline.css';
import { EmptyFieldWarning } from '../EmptyFieldWarning';
import { LoadMoreButton } from '../LoadMoreButton';

export function EHRTimeline() {
  const [timelineFilter, setTimelineFilter] = useState('Todos');
  const { patientTimeline, ehrState } = useEHRContext();
  // const timelineDivRef = useRef();
  const [paginationNextUrl, setPaginationNextUrl] = useState('');
  const [timelineList, setTimelineList] = useState([]);
  const [loadingMoreDocuments, setLoadingMoreDocuments] = useState(false);
  // const [isListOpen, setIsListOpen] = useState(false);
  const filteredTimeline = timelineList?.filter(
    ({ resource }) => {
      const docTypeObject = docTypes.find((docType) => docType.name === timelineFilter);
      return docTypeObject.codes.map(
        (code) => resource.type.coding[0].code.includes(code),
      ).includes(true);
    },
  );

  const dateCards = [];
  filteredTimeline.forEach((element) => {
    const isoDate = element?.resource?.context?.period?.end || element?.resource?.context?.period?.start;
    const month = monthNames[fixTimezoneOffset(new Date(isoDate)).getMonth() + 1];
    const year = fixTimezoneOffset(new Date(isoDate)).getFullYear();
    if (!dateCards.includes(`${month} - ${year}`)) dateCards.push(`${month} - ${year}`);
    else dateCards.push('');
  });

  async function getTokens() {
    await xdsToken.getBearerToken();
    const bearerToken = await retrieveData('application_token');
    const xUserToken = await retrieveData('token');
    return { bearerToken, xUserToken };
  }

  function handleUpdateTimeline() {
    try {
      if (paginationNextUrl) {
        setLoadingMoreDocuments(true);
        const link = `${endpoints.MHD}?${paginationNextUrl.split('?')[1]}`;

        getTokens().then((tokens) => {
          const headers = {
            authorization: `Bearer ${ehrState.subject.token || tokens.bearerToken}`,
            'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
            'Content-Type': 'application/fhir+json',
            Accept: 'application/fhir+json',
            purposeofuse: 'Atendimento',
            ...(ehrState.subject.organizationId && { 'organization-id': ehrState.subject.organizationId }),
            ...(ehrState.resource.id && currentMode === 'aghu' && { 'resource-id': ehrState.resource.id }),
            ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
          };
          axios({
            method: 'get', url: link, headers, timeout: 5000,
          })
            .then(async ({ data: response }) => {
              toast.success(<ToastMessage type="success"> Requisição completada.</ToastMessage>);
              setTimelineList([...timelineList, ...response.entry]);
              setPaginationNextUrl(response.link.find(({ relation }) => relation === 'next')?.url);
            })
            .catch((err) => {
              try {
                logDebug(err);
                toast.error(<ToastMessage type="error"> Requisição completada.</ToastMessage>);
              } catch {
                // toast de error
              }
            })
            .then(() => {
              setLoadingMoreDocuments(false);
            });
        });
      }
    } catch (err) {
      logDebug(err);
    }
  }

  useEffect(() => {
    if (Array.isArray(patientTimeline?.link)) {
      setPaginationNextUrl(patientTimeline?.link.length > 1 ? patientTimeline?.link.find(
        ({ relation }) => relation === 'next',
      ).url : '');
    }
    if (Array.isArray(patientTimeline?.entry)) setTimelineList(patientTimeline?.entry);
  }, [patientTimeline]);

  return (
    <>
      {patientTimeline?.entry?.length ? (
        <>
          <div className="EHRfilterButtons">
            <button
              className={timelineFilter === 'Todos' && 'EHRfilterButtons-selected'}
              onClick={() => setTimelineFilter('Todos')}
            >
              Todos
            </button>
            <button
              className={timelineFilter === 'Sumário de Alta' && 'EHRfilterButtons-selected'}
              onClick={() => setTimelineFilter('Sumário de Alta')}
            >
              Sumário de Alta
            </button>
            <button
              className={timelineFilter === 'Registro de Atendimento Clínico' && 'EHRfilterButtons-selected'}
              onClick={() => setTimelineFilter('Registro de Atendimento Clínico')}
            >
              Registro de Atendimento Clínico
            </button>
          </div>
          <div
            className="ehrTimeline-container"
          >
            <Timeline>
              {filteredTimeline.map((element, index) => {
                const auxDate = element?.resource?.context?.period?.end || element?.resource?.context?.period?.start;
                const auxType = element.resource.type.coding[0].code;
                const auxPractitioner = element.resource.contained.find(
                  ({ resourceType }) => resourceType === 'Practitioner',
                );
                const auxPractitionerId = auxPractitioner?.identifier[0].value;
                let auxPractitionerName = auxPractitioner?.name?.find(({ given }) => given)?.given;
                if (Array.isArray(auxPractitionerName)) auxPractitionerName = auxPractitionerName[0];

                const auxOrganization = element?.resource?.contained?.find(
                  ({ resourceType }) => resourceType === 'Organization',
                );

                // const auxOrganizationId = auxOrganization.identifier[0].value;
                const auxOrganizationAlias = auxOrganization.alias ? auxOrganization.alias[0] : auxOrganization.name || 'Não Encontrado';
                const auxOrganizationName = auxOrganization && auxOrganization.name;
                const auxDocumentBinaryId = element.resource.masterIdentifier.value
                  .split('urn:oid:')[1];
                return (
                  <>
                    {dateCards[index] && (
                      <TimelineItem key={`timelineDateItemCard-${dateCards[index]}`}>
                        <TimelineSeparator>
                          <TimelineDot className="highlight" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>
                          <div className="ehrTimeline-dateCard">{dateCards[index]}</div>
                        </TimelineContent>
                      </TimelineItem>
                    )}
                    <TimelineItem key={`timelineItemCard-${element.resource.id}`}>
                      <TimelineSeparator>
                        <TimelineDot />
                        {index !== filteredTimeline.length - 1 && (<TimelineConnector />)}
                      </TimelineSeparator>
                      <TimelineContent>
                        <EHRTimelineCard
                          documentBinaryId={auxDocumentBinaryId}
                          date={auxDate || ''}
                          type={auxType}
                          organizationName={auxOrganizationName}
                          practitioner={auxPractitionerName || auxPractitionerId}
                          alias={auxOrganizationAlias}
                        />
                      </TimelineContent>
                    </TimelineItem>
                  </>
                );
              })}
            </Timeline>
            {(paginationNextUrl && filteredTimeline.length > 4 && patientTimeline.total > 5) && (
              <LoadMoreButton onClick={handleUpdateTimeline} />
            ) }
          </div>
        </>

      ) : (
        <EmptyFieldWarning />
      )}
    </>
  );
}
